import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import ManageDmsBucketDetails from './ManageDmsBucketDetails';

const ManageDmsBucketDetailsWrapper = (props) => {
    const { themeSelected, onThemechange } = props;

    return (
        <div className="container-fluid">
            <Header {...props} />
            <Navigationbar {...props} />
            <div className="content-wrapper mt-3">
                <ManageDmsBucketDetails themeSelected={themeSelected} />
            </div>
        </div>
    );
};

export default ManageDmsBucketDetailsWrapper;